<template>
  <el-sub-menu :index="menu.categoryId.toString()" v-if="menu.children">
    <template #title>
<!--      <el-icon><Folder /></el-icon>-->
      <span>{{ menu.name }}</span>
    </template>
    <ProductLeftSubMenu
      :menu="menuItem"
      v-for="menuItem in menu.children"
      :key="menuItem.categoryId"
      @category-change="onCategoryChange"
    ></ProductLeftSubMenu>
  </el-sub-menu>
  <el-menu-item :index="menu.categoryId.toString()" v-else @click="onCategoryChange(menu.categoryId)">
<!--    <el-icon><Document /></el-icon>-->
    <span>{{ menu.name }}</span>
  </el-menu-item>
</template>

<script setup>
import { Folder, Document } from '@element-plus/icons-vue'

// 定义props
defineProps({
  menu: {
    type: Object,
    default: () => ({}),
  }
})

const emit = defineEmits(['category-change']);

const onCategoryChange = (categoryId) => {
  emit('category-change', String(categoryId));
};
</script>

<style lang='less' scoped>
.el-icon {
  margin-right: 5px;
}
</style>
